import React, { useEffect, useState } from "react";
import "./How_It_Works.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import Multimedia_Services_Benefits_card from "../../../Common_Component/Multimedia_Services_Benefits_card/Multimedia_Services_Benefits_card";
import { useParams } from "react-router-dom";

const How_It_Works = () => {
  const [howItWorksData, setHowItWorksData] = useState([]);
  const { id } = useParams();

  console.log("howItWorksData", howItWorksData);

  const data = [
    {
      id: "1",
      sub_title:
        "We tailor a multi-faceted strategy that aligns with your brand’s goals",
      innerData: [
        {
          id: 1,
          title: "Platform Selection",
          descn:
            "Identifying the right platforms based on your target audience and industry.",
          image:
            "/Assets/Images/Service/Services/digital_media/how_it_works/social_media/img1.png",
        },
        {
          id: 1,
          title: "Content Strategy",
          descn:
            "Creating visually engaging and emotionally impactful posts, videos, stories, and reels.",
          image:
            "/Assets/Images/Service/Services/digital_media/how_it_works/social_media/img2.png",
        },
        {
          id: 1,
          title: "Targeted Ads",
          descn:
            "Running highly focused ad campaigns based on demographics, interests, & behaviours.",
          image:
            "/Assets/Images/Service/Services/digital_media/how_it_works/social_media/img3.png",
        },
        {
          id: 1,
          title: "Community Engagement",
          descn:
            "Responding to comments, messages, and reviews to build a loyal customer base.",
          image:
            "/Assets/Images/Service/Services/digital_media/how_it_works/social_media/img4.png",
        },
        {
          id: 1,
          title: "Performance Analytics",
          descn:
            "Continuously monitoring and optimizing your campaigns for better results.",
          image:
            "/Assets/Images/Service/Services/digital_media/how_it_works/social_media/img5.png",
        },
      ],
    },
    {
      id: "2",
      sub_title: "We craft customized PPC campaigns designed to convert",
      innerData: [
        {
          id: 1,
          title: "Keyword Research",
          descn:
            "We identify high-value keywords your audience is actively searching for.",
          image:
            "/Assets/Images/Service/Services/digital_media/how_it_works/PPC/img1.png",
        },
        {
          id: 1,
          title: "Ad Creation",
          descn:
            "Creating visually engaging and emotionally impactful posts, videos, stories, and reels.",
          image:
            "/Assets/Images/Service/Services/digital_media/how_it_works/PPC/img2.png",
        },
        {
          id: 1,
          title: "Targeting",
          descn:
            "Define precise audiences based on demographics, geography, interests, and behaviour.",
          image:
            "/Assets/Images/Service/Services/digital_media/how_it_works/PPC/img3.png",
        },
        {
          id: 1,
          title: "Landing Page Optimization",
          descn:
            "Ensure users are directed to pages optimized for conversions.",
          image:
            "/Assets/Images/Service/Services/digital_media/how_it_works/PPC/img4.png",
        },
        {
          id: 1,
          title: "Continuous Optimization",
          descn:
            "Monitor and tweak campaigns for better performance and lower costs.",
          image:
            "/Assets/Images/Service/Services/digital_media/how_it_works/PPC/img5.png",
        },
      ],
    },
    {
      id: "3",
      sub_title:
        "We combine creativity, technical expertise, and user-centric design to build or optimize your website:",
      innerData: [
        {
          id: 1,
          title: "Custom Website Design",
          descn:
            "Create visually stunning and functional websites tailored to your brand and goals.",
          image:
            "/Assets/Images/Service/Services/digital_media/how_it_works/web_dev/img1.png",
        },
        {
          id: 1,
          title: "Responsive Development",
          descn:
            "Ensure your website looks & performs flawlessly across all devices -desktop, tablet, & mobile.",
          image:
            "/Assets/Images/Service/Services/digital_media/how_it_works/web_dev/img2.png",
        },
        {
          id: 1,
          title: "SEO Integration ",
          descn:
            "Optimize site structure, content, and speed to rank higher in search engine results.",
          image:
            "/Assets/Images/Service/Services/digital_media/how_it_works/web_dev/img3.png",
        },
        {
          id: 1,
          title: "Performance Optimization",
          descn:
            "Improve load times, eliminate bugs, & enhance navigation for a better user experience.",
          image:
            "/Assets/Images/Service/Services/digital_media/how_it_works/web_dev/img4.png",
        },
        {
          id: 1,
          title: "Ongoing Maintenance",
          descn:
            "Regular updates and security checks to keep your site running smoothly.",
          image:
            "/Assets/Images/Service/Services/digital_media/how_it_works/web_dev/img5.png",
        },
      ],
    },
    {
      id: "4",
      sub_title:
        "We craft tailored content marketing strategies designed to meet your business objectives:",
      innerData: [
        {
          id: 1,
          title: "Audience Research",
          descn:
            "Understand your audience’s pain points, preferences, and behaviors.",
          image:
            "/Assets/Images/Service/Services/digital_media/how_it_works/web_dev/img1.png",
        },
        {
          id: 2,
          title: "Content Strategy",
          descn:
            "Develop a content plan that aligns with your brand’s goals and resonates with your audience.",
          image:
            "/Assets/Images/Service/Services/digital_media/how_it_works/web_dev/img2.png",
        },
        {
          id: 3,
          title: "High-Quality Content Creation",
          descn:
            "Produce blogs, videos, infographics, case studies, and more that inform, entertain, or solve problems.",
          image:
            "/Assets/Images/Service/Services/digital_media/how_it_works/web_dev/img3.png",
        },
        {
          id: 4,
          title: "SEO Integration",
          descn:
            "Use targeted keywords to boost search engine rankings and drive organic traffic.",
          image:
            "/Assets/Images/Service/Services/digital_media/how_it_works/web_dev/img4.png",
        },
        {
          id: 5,
          title: "Content Distribution",
          descn:
            "Share content through your website, social media, email campaigns, and other platforms for maximum reach.",
          image:
            "/Assets/Images/Service/Services/digital_media/how_it_works/web_dev/img5.png",
        },
        {
          id: 6,
          title: "Performance Tracking",
          descn:
            "Monitor metrics like engagement, traffic, and conversions to refine your strategy.",
          image:
            "/Assets/Images/Service/Services/digital_media/how_it_works/web_dev/img1.png",
        },
      ],
    },
    {
        id: "5",
        sub_title: "We deploy a comprehensive strategy to safeguard and enhance your brand’s online image:",
        innerData: [
            {
                id: 1,
                title: "Reputation Assessment",
                descn: "Analyze existing online mentions, reviews, and sentiment about your brand.",
                image: "/Assets/Images/Service/Services/digital_media/how_it_works/web_dev/img1.png"
            },
            {
                id: 2,
                title: "Review Monitoring",
                descn: "Track and manage reviews across platforms like Google, Yelp, Facebook, and industry-specific directories.",
                image: "/Assets/Images/Service/Services/digital_media/how_it_works/web_dev/img2.png"
            },
            {
                id: 3,
                title: "Feedback Response",
                descn: "Respond to positive reviews to build engagement and address negative reviews tactfully to showcase accountability.",
                image: "/Assets/Images/Service/Services/digital_media/how_it_works/web_dev/img3.png"
            },
            {
                id: 4,
                title: "Content Creation",
                descn: "Publish positive news, customer testimonials, and PR campaigns to improve your brand’s visibility.",
                image: "/Assets/Images/Service/Services/digital_media/how_it_works/web_dev/img4.png"
            },
            {
                id: 5,
                title: "Search Engine Optimization",
                descn: "Promote favorable content and suppress negative mentions in search results.",
                image: "/Assets/Images/Service/Services/digital_media/how_it_works/web_dev/img5.png"
            },
            {
                id: 6,
                title: "Crisis Management",
                descn: "Handle any reputational crises quickly and effectively to minimize impact.",
                image: "/Assets/Images/Service/Services/digital_media/how_it_works/web_dev/img5.png"
            }
        ]
    },

    {
      id: "6",
      sub_title:
        "We implement a holistic SEO strategy tailored to your business goals:",
      innerData: [
        {
          id: 1,
          title: "Keyword Research",
          descn:
            "Identify high-traffic and relevant keywords your audience is searching for.",
          image:
            "/Assets/Images/Service/Services/digital_media/how_it_works/web_dev/img1.png",
        },
        {
          id: 1,
          title: "On-Page Optimization",
          descn:
            "Optimize meta titles, descriptions, headers, images, and internal links.",
          image:
            "/Assets/Images/Service/Services/digital_media/how_it_works/web_dev/img2.png",
        },
        {
          id: 1,
          title: "Content Creation ",
          descn:
            "Develop high-quality, keyword-rich content that engages users and ranks well.",
          image:
            "/Assets/Images/Service/Services/digital_media/how_it_works/web_dev/img3.png",
        },
        {
          id: 1,
          title: "Technical SEO",
          descn:
            "Enhance site speed, mobile responsiveness, crawlability, and indexability for better performance.",
          image:
            "/Assets/Images/Service/Services/digital_media/how_it_works/web_dev/img4.png",
        },
        {
          id: 1,
          title: "Link Building",
          descn:
            "Build high-quality backlinks from authoritative websites to boost your site’s credibility.",
          image:
            "/Assets/Images/Service/Services/digital_media/how_it_works/web_dev/img5.png",
        },

        {
          id: 1,
          title: "Local SEO",
          descn:
            "Optimize your online presence for local searches with Google My Business and localized content.",
          image:
            "/Assets/Images/Service/Services/digital_media/how_it_works/web_dev/img5.png",
        },
        {
          id: 1,
          title: "Performance Tracking",
          descn:
            "Monitor traffic, rankings, and conversions to continuously refine strategies.",
          image:
            "/Assets/Images/Service/Services/digital_media/how_it_works/web_dev/img5.png",
        },
      ],
    },

    {
      id: "7",
      sub_title:
        "We craft strategic email marketing campaigns designed to deliver results:",
      innerData: [
        {
          id: 1,
          title: "Audience Segmentation",
          descn:
            "Group your audience based on demographics, behavior, or interests for personalized messaging.",
          image:
            "/Assets/Images/Service/Services/digital_media/how_it_works/web_dev/img1.png",
        },
        {
          id: 2,
          title: "Compelling Content Creation",
          descn:
            "Write engaging subject lines, clear CTAs, and value-driven email content.",
          image:
            "/Assets/Images/Service/Services/digital_media/how_it_works/web_dev/img2.png",
        },
        {
          id: 3,
          title: "Custom Templates",
          descn:
            "Design visually appealing email templates aligned with your brand identity.",
          image:
            "/Assets/Images/Service/Services/digital_media/how_it_works/web_dev/img3.png",
        },
        {
          id: 4,
          title: "Automation & Drip Campaigns",
          descn:
            "Schedule sequences to nurture leads over time or trigger emails based on user actions.",
          image:
            "/Assets/Images/Service/Services/digital_media/how_it_works/web_dev/img4.png",
        },
        {
          id: 5,
          title: "Performance Analytics",
          descn:
            "Monitor open rates, click-through rates, and conversions to optimize campaigns.",
          image:
            "/Assets/Images/Service/Services/digital_media/how_it_works/web_dev/img5.png",
        },
      ],
    },

    {
      id: "8",
      sub_title:
        "We design and execute influencer marketing campaigns tailored to your goals:",
      innerData: [
        {
          id: 1,
          title: "Identifying Influencers",
          descn:
            "Find influencers whose audience aligns with your target market.",
          image:
            "/Assets/Images/Service/Services/digital_media/how_it_works/web_dev/img1.png",
        },
        {
          id: 2,
          title: "Strategy Development",
          descn: "Define campaign objectives, deliverables, and messaging.",
          image:
            "/Assets/Images/Service/Services/digital_media/how_it_works/web_dev/img2.png",
        },
        {
          id: 3,
          title: "Content Collaboration",
          descn:
            "Work with influencers to create engaging, brand-specific content, such as posts, stories, reels, or videos.",
          image:
            "/Assets/Images/Service/Services/digital_media/how_it_works/web_dev/img3.png",
        },
        {
          id: 4,
          title: "Campaign Execution",
          descn:
            "Launch campaigns at the right time to maximize engagement and visibility.",
          image:
            "/Assets/Images/Service/Services/digital_media/how_it_works/web_dev/img4.png",
        },
        {
          id: 5,
          title: "Performance Tracking",
          descn:
            "Measure metrics like reach, engagement, clicks, and conversions to evaluate success.",
          image:
            "/Assets/Images/Service/Services/digital_media/how_it_works/web_dev/img5.png",
        },
      ],
    },

    {
      id: "9",
      sub_title:
        "We design and execute WhatsApp campaigns tailored to your marketing goals:",
      innerData: [
        {
          id: 1,
          title: "Building Your List",
          descn:
            "Compile a targeted list of customer contacts based on your audience segmentation.",
          image:
            "/Assets/Images/Service/Services/digital_media/how_it_works/web_dev/img1.png",
        },
        {
          id: 2,
          title: "Message Strategy",
          descn:
            "Craft concise and engaging messages aligned with your objectives, including text, images, videos, or links.",
          image:
            "/Assets/Images/Service/Services/digital_media/how_it_works/web_dev/img2.png",
        },
        {
          id: 3,
          title: "Campaign Scheduling",
          descn:
            "Plan the best time to send messages to maximize visibility and response rates.",
          image:
            "/Assets/Images/Service/Services/digital_media/how_it_works/web_dev/img3.png",
        },
        {
          id: 4,
          title: "Delivery Optimization",
          descn:
            "Use advanced tools to ensure messages reach your audience reliably and comply with WhatsApp’s policies.",
          image:
            "/Assets/Images/Service/Services/digital_media/how_it_works/web_dev/img4.png",
        },
        {
          id: 5,
          title: "Performance Tracking",
          descn:
            "Monitor delivery rates, read rates, and engagement to evaluate campaign success.",
          image:
            "/Assets/Images/Service/Services/digital_media/how_it_works/web_dev/img5.png",
        },
      ],
    },

    {
      id: "10",
      sub_title:
        "We design and manage SMS campaigns tailored to your business objectives:",
      innerData: [
        {
          id: 1,
          title: "Building Your Audience List",
          descn:
            "Segment your customer base to target the right audience with relevant messages.",
          image:
            "/Assets/Images/Service/Services/digital_media/how_it_works/web_dev/img1.png",
        },
        {
          id: 2,
          title: "Message Crafting",
          descn:
            "Develop concise, impactful SMS content within the 160-character limit, focusing on clear calls to action.",
          image:
            "/Assets/Images/Service/Services/digital_media/how_it_works/web_dev/img2.png",
        },
        {
          id: 3,
          title: "Scheduling Campaigns",
          descn:
            "Strategically plan the timing of your messages to maximize visibility and engagement.",
          image:
            "/Assets/Images/Service/Services/digital_media/how_it_works/web_dev/img3.png",
        },
        {
          id: 4,
          title: "Campaign Delivery",
          descn:
            "Send bulk messages quickly using robust delivery systems to ensure maximum reach.",
          image:
            "/Assets/Images/Service/Services/digital_media/how_it_works/web_dev/img4.png",
        },
        {
          id: 5,
          title: "Tracking Results",
          descn:
            "Monitor delivery rates, click-throughs, and responses to measure campaign performance and ROI.",
          image:
            "/Assets/Images/Service/Services/digital_media/how_it_works/web_dev/img5.png",
        },
      ],
    },

    {
      id: "11",
      sub_title:
        "We design and manage SMS campaigns tailored to your business objectives:",
      innerData: [
        {
          id: 1,
          title: "Voice Call - Record Personalized Messages",
          descn:
            "Record personalized voice messages tailored to your campaign objectives.",
          image:
            "/Assets/Images/Service/Services/digital_media/how_it_works/web_dev/img1.png",
        },
        {
          id: 2,
          title: "Voice Call - Automated Delivery",
          descn:
            "Use automated systems to deliver calls to your target audience.",
          image:
            "/Assets/Images/Service/Services/digital_media/how_it_works/web_dev/img2.png",
        },
        {
          id: 3,
          title: "Voice Call - Interactive IVR Menus",
          descn:
            "Include interactive options like IVR menus for further engagement.",
          image:
            "/Assets/Images/Service/Services/digital_media/how_it_works/web_dev/img3.png",
        },
        {
          id: 4,
          title: "Missed Call System - Dedicated Number",
          descn:
            "Promote a dedicated number for customers to give a missed call.",
          image:
            "/Assets/Images/Service/Services/digital_media/how_it_works/web_dev/img4.png",
        },
        {
          id: 5,
          title: "Missed Call System - Instant Capture",
          descn:
            "Instantly capture the caller’s number for follow-ups or automated responses.",
          image:
            "/Assets/Images/Service/Services/digital_media/how_it_works/web_dev/img5.png",
        },
        {
          id: 6,
          title: "Missed Call System - Instant SMS or Callback",
          descn: "Send instant SMS or callback to engage the customer further.",
          image:
            "/Assets/Images/Service/Services/digital_media/how_it_works/web_dev/img5.png",
        },
      ],
    },
  ];

  useEffect(() => {
    const filteredArray = data?.filter((item) => item?.id === id);

    console.log("filteredArray", filteredArray);

    setHowItWorksData(filteredArray);
  }, [id]);

  return (
    <div className="How_It_Works_Digital_Media">
      <div className="container">
        <div className="main_div_holder">
          <div className="top_text_holder">
            <div className="title_div">
              <p className="title">How it Works</p>
            </div>
            <div className="sub_title_div">
              <p className="sub_title">{howItWorksData?.[0]?.sub_title}</p>
            </div>
          </div>

          <div className="card_holder_main_div">
            <Swiper
              className="mySwiper"
              spaceBetween={10}
              slidesPerView={6}
              modules={[Pagination]}
              pagination={{
                dynamicBullets: true,
                clickable: true,
              }}
              breakpoints={{
                // when window width is >= 320px
                0: {
                  slidesPerView: 1,
                  spaceBetween: 10,
                },
                425: {
                  slidesPerView: 1.5,
                  spaceBetween: 15,
                },
                480: {
                  slidesPerView: 1.8,
                  spaceBetween: 15,
                },
                // when window width is >= 768px
                768: {
                  slidesPerView: 3,
                  spaceBetween: 20,
                },
                // when window width is >= 1024px
                991: {
                  slidesPerView: 4,
                  spaceBetween: 25,
                },
                1400: {
                  slidesPerView: 5,
                  spaceBetween: 25,
                },
              }}
            >
              {howItWorksData?.[0]?.innerData?.length > 0 &&
                howItWorksData?.[0]?.innerData?.map((item) => {
                  return (
                    <SwiperSlide>
                      <Multimedia_Services_Benefits_card
                        headingText={item?.title}
                        text={item?.descn}
                        image={item?.image}
                      />
                    </SwiperSlide>
                  );
                })}
            </Swiper>
          </div>
        </div>
      </div>
    </div>
  );
};

export default How_It_Works;
